export default __webpack_public_path__ + "static/media/ThreeDotsActive.5cac507d.svg";